import { t } from "i18next";
import { UserData } from "../../User/UserData";

export class SubtaskStatus {
  id: number;
  name: string;
  changedDate?: Date;
  changedBy?: UserData;

  static NOT_DONE = new SubtaskStatus(0, t("main.notDone"));
  static DONE = new SubtaskStatus(1, t("main.subtaskDone"));

  constructor(id: number, name: string) {
    this.id = id;
    this.name = name;
  }

  static getStatusWithId(id: number): SubtaskStatus {
    if (id === 1) {
      return SubtaskStatus.DONE;
    }
    return SubtaskStatus.NOT_DONE;
  }
}
